export default __webpack_public_path__ + "static/media/wood_natural.13e64099.jpg";